import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscriber } from './../../models/newsletter/subscribers.model';
import { PaginationParams } from './../../models/shared/paginationParams.model';
import { Subscription } from 'rxjs';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';

@Component({
  selector: 'swb-subscribers',
  templateUrl: './subscribers.component.html'
})
export class SubscribersComponent implements OnInit, OnDestroy {
  private _subscription: Subscription;
  public q = '';
  public isInitialized = false;

  @Input()
  set query(query: string) {
    if (query) {
      this.q = query;
      this._getPaginationParams(query);
      this.p = 1;
      this._getSubscribers(query, '/filter/');
    } else {
      this.q = '';
      this._getPaginationParams('');
      this._getSubscribers(this.q, '');
    }
  }

  public subscribers: Subscriber[];

  public pagination: PaginationParams = {
    pageSize: 0,
    total: 0
  };

  public p = 1;

  constructor(
    private _apiService: ApiService,
    private _communicationService: CommunicationService
  ) { }

  ngOnInit() {
    this._subscription = this._communicationService.modalExecuted$.subscribe((event) => {
      this._getPaginationParams('');
      this._getSubscribers(this.q, '');
    });

    this._getPaginationParams('');
    this._getSubscribers(this.q, '');
  }

  public pageChanged(p): void {
    this.p = p;
    let uri = '';
    if (this.q.length > 0) {
      uri = '/filter/';
    }
    this._getSubscribers(this.q, uri);
  }

  private _getSubscribers(query: string, uri: string) {
    this._apiService.get('subscribers' + uri + query + '?page=' + this.p)
      .subscribe(
        (response: any) => {
          this.subscribers = { ...response }.data;
          this.isInitialized = true;
        },
        (error) => console.error(error)
      );
  }

  private _getPaginationParams(query: string) {
    this._apiService.get('subscribers/pagination/' + query)
      .subscribe(
        (response: any) => {
          this.pagination = { ...response?.data };
        },
        (error) => console.error(error)
      );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

}
